import { EPaymentPlan } from '@if/core/types'
import { formatCurrency } from '@if/core/utils'
import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { FundingComputedDto } from '../../../../data/types/FundingComputedDto'
import { IFinanceBaseWorksheet } from '../../../../data/types/IFinanceBaseWorksheetSchema'
import { MerchantPaymentPlan } from '../../../../data/types/MerchantPaymentPlan'
import { computeTotalCoverageFromFunding } from '../../../../services/WorksheetComputer'

interface Props {
  worksheet: IFinanceBaseWorksheet
  computedInfo: FundingComputedDto
  merchantPaymentPlan: MerchantPaymentPlan | null
}

const LoanSummaryBox = ({ worksheet, computedInfo, merchantPaymentPlan }: Props) => {
  const { t } = useTranslation()

  const totalFees = computedInfo?.lenderFee ?? 0
  const totalCoverage = computeTotalCoverageFromFunding(computedInfo)

  const getMerchantFees = () => {
    if (merchantPaymentPlan && worksheet.amountRequested) {
      return formatCurrency((merchantPaymentPlan.merchantFeeRate / 100) * worksheet.amountRequested)
    }
    return ''
  }

  return (
    <>
      <Typography variant="h6" component="h3" gutterBottom>
        {t('worksheet.sideSection.loanSummary')}
      </Typography>
      <Stack direction="row" justifyContent="space-between" marginLeft={5} marginRight={5}>
        <Typography variant="subtitle1">{t('worksheetCommon.amountRequested')} :</Typography>
        <Typography variant="subtitle1">{formatCurrency(worksheet?.amountRequested)}</Typography>
      </Stack>
      <Stack direction="row" justifyContent="space-between" marginLeft={5} marginRight={5}>
        <Typography variant="subtitle1">
          {t('worksheetCommon.financeFee')} ({worksheet?.lenderFeeRate}%) :
        </Typography>
        <Typography variant="subtitle1">{formatCurrency(totalFees)}</Typography>
      </Stack>
      {merchantPaymentPlan && worksheet?.paymentPlanId !== EPaymentPlan.RegularDailyInterests && (
        <Stack direction="row" justifyContent="space-between" marginLeft={5} marginRight={5}>
          <Typography variant="subtitle1">
            {t('worksheetCommon.merchantFee')} ({merchantPaymentPlan.merchantFeeRate}%) :
          </Typography>
          <Typography variant="subtitle1">{getMerchantFees()}</Typography>
        </Stack>
      )}
      <Stack direction="row" justifyContent="space-between" marginLeft={5} marginRight={5}>
        <Typography variant="subtitle1">{t('worksheetCommon.protectionPlan')} :</Typography>
        <Typography variant="subtitle1">{formatCurrency(totalCoverage)}</Typography>
      </Stack>
      <Stack direction="row" justifyContent="space-between" marginLeft={5} marginRight={5}>
        <Typography variant="subtitle1">{t('worksheet.totalAmountFinanced')} :</Typography>
        <Typography variant="subtitle1">{formatCurrency(worksheet?.totalAmountFinanced)}</Typography>
      </Stack>
    </>
  )
}

export default LoanSummaryBox
